module.exports = __webpack_public_path__ + "img/bot_event_info_day4.d7e332cf.png";